import { DialogProvider } from '@mews-commander/ui';
import { ApplicationState } from '@mews-commander/types';
import { ArticlePath, createGuideLink } from '@mews-commander/enums';
import { isCurrentEnterprisePortfolio } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import {
    hasCurrentProfilePlatformScope,
    isCurrentProfileAdmin,
} from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { hasCurrentEnterpriseSsoAccess } from '@mews-commander/legacy-entities/src/selectors/session/enterpriseProductSubscriptions';
import { UserGroupsList } from './components/UserGroupsList';
import { Layout } from './components/Layout';

export const hasPrivilegeToViewUserGroups = (state: ApplicationState) =>
    isCurrentEnterprisePortfolio(state) &&
    (isCurrentProfileAdmin(state) || hasCurrentProfilePlatformScope(state)) &&
    hasCurrentEnterpriseSsoAccess(state);

export const UserGroupsView = () => {
    const guideLink = createGuideLink(ArticlePath.UserGroupsListIndex);
    return (
        <DialogProvider>
            <Layout guideLink={guideLink}>
                <UserGroupsList />
            </Layout>
        </DialogProvider>
    );
};
